import { Controller } from '@hotwired/stimulus';
import csrfToken from '@cta/shared/csrf';

export default class extends Controller {
  async redirect({ params: { sharingButtonId, sharingContentId } }) {
    await this.createRecommendIntention(sharingButtonId, sharingContentId, (redirectUrl) => {
      document.location = redirectUrl;
    });
  }

  async registerCopyRecommendIntention({ params: { sharingButtonId, sharingContentId } }) {
    await this.createRecommendIntention(sharingButtonId, sharingContentId);
  }

  async createRecommendIntention(sharingButtonId, sharingContentId, callback) {
    const recommendUrl = new URL(document.querySelector('.content').dataset.recommendUrl);
    recommendUrl.searchParams.set('sharing_button_id', sharingButtonId);
    if (sharingContentId) {
      recommendUrl.searchParams.set('sharing_content_id', sharingContentId);
    }

    const response = await fetch(recommendUrl.toString(), {
      method: 'post',
      headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
    });

    const json = await response.json();
    if (callback) callback(json.redirectUrl);
  }
}
